import { SnapPick, Vector3 } from '@technology/web3d';
import { formatLength, LengthUnit } from '@fulcrum/lib';
import { convertMetersToMillimeters } from '../unit-of-measure/unit-conversions';

const DEFAULT_DECIMAL_PLACES = 2;

export function calculateDistance(p1: Vector3, p2: Vector3): number {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const dz = p2.z - p1.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

export function chainDistance(picks: SnapPick[]): number {
  return picks.reduce((acc, pick, index) => {
    const nextPick = picks[index + 1];
    if (!nextPick || !pick.point || !nextPick.point) {
      return acc;
    }
    return acc + calculateDistance(pick.point, nextPick.point);
  }, 0);
}

export function calculateHorizontalDistance(p1: Vector3, p2: Vector3): number {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx * dx + dy * dy);
}

export function calculateVerticalDistance(p1: Vector3, p2: Vector3): number {
  return Math.abs(p2.z - p1.z);
}

export function formatDistance(
  distance: number,
  unit: LengthUnit = 'm',
  decimalPlaces: number = DEFAULT_DECIMAL_PLACES
): string {
  // Convert distance from meters to millimeters for formatLength
  return formatLength(
    convertMetersToMillimeters(distance),
    unit,
    decimalPlaces
  );
}
